import { createContainer } from './models/Container';
import { ProductData } from './models/modelTypes';

export const productsContainer = createContainer<ProductData>();
export type ProductsContainer = typeof productsContainer;
